module.exports = __webpack_public_path__ + "static/img/3en.ca033d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/realme/3en.png
// module id = 53bk
// module chunks = 0